<template>
  <div class="index">
    <div class="logo LeftBottom"><img src="../assets/logo.png" alt=""></div>
    <div class="pen"><img src="../assets/1/pen.png" class="wid100" alt=""></div>
    <div class="mapCon Center">
      <div class="map">
        <div class="map_bg">
          <img src="../assets/1/map750.png" class="wid100" alt="">
        </div>
        <div class="title End">
          <img src="../assets/1/1.png" class="wid100" alt="">
        </div>
        <div class="map_mask">
          <img src="../assets/1/mask.png" class="hei100 wid100" alt="">
        </div>
        <div class="LootBox">
          <div v-for="box in displayBoxes" :key="box.id" class="box"  :style="{ top: box.top, left: box.left, position: 'absolute' }">
            <img :src="getBoxImage(box.id)" :data-id="box.id" class="boxImg" alt="" @click="handleBoxClick(box.id)">
            <img src="../assets/1/2.png" class="light" alt="">
          </div>
        </div>
        <div class="manBtn" v-if="IsBegin">
          <img src="../assets/btn/2.png" v-if="!beginBtn" class="btnAni"  @click="GameBeginTips" alt="">
          <img src="../assets/btn/4.png" v-if="beginBtn"  @click="GameBegin" alt="">
          <img src="../assets/btn/3.png" v-if="DrawBtn" @click="requestLottery" alt="">
        </div>
      </div>
      <div class="nav">
        <span @click="getMyPrize">我的奖品</span>
        <span @click="showRule = true">活动规则</span>
      </div>
    </div>
    <div class="binocle">
      <img src="../assets/1/binocle.png" class="wid100" alt="">
    </div>
    <transition name="fade">
      <rule v-if="showRule" @close="showRule = false"></rule>
    </transition>
    <transition name="fade">
      <MyPrize v-if="showMyPrize" :level="myPrizeLevel" @close="showMyPrize = false"></MyPrize>
    </transition>
    <transition name="fade">
      <BoxShow v-if="showBox" :BoxData="BoxData" @close="showBox = false"></BoxShow>
    </transition>
    <transition name="fade">
      <Begin v-if="ShowBegin" @close="BeginFun" ></Begin>
    </transition>
    <transition name="fade">
      <Lottery v-if="showLottery" :LTipsType="LotteryTipsType"  @userShare="userShare" @close="showLottery = false"></Lottery>
    </transition>
    <transition name="fade">
      <share v-if="shareBox" @close="shareBox = false"></share>
    </transition>
  </div>
</template>

<script>
import rule from "../components/rule";
import MyPrize from "../components/MyPrize";
import BoxShow from "../components/BoxShow";
import Begin from "../components/begin";
import Lottery from "../components/Lottery";
import share from "../components/share";
import '@/store' // 确保 setActivePinia 在此处生效
import {reqUserInfo,submitAns,reqDraw } from '@/api';
const positions = [
  { top: '5%', left: '0%',url:require('../assets/card/2/1.png') },
  { top: '0%', left: '34%',url:require('../assets/card/2/2.png') },
  { top: '20%', left: '19%',url:require('../assets/card/2/3.png') },
  { top: '21%', left: '54%',url:require('../assets/card/2/4.png')},
  { top: '35%', left: '0%' ,url:require('../assets/card/1/1.png')},
  { top: '41%', left: '35%',url:require('../assets/card/1/2.png') },
  { top: '40%', left: '60%',url:require('../assets/card/1/3.png') },
  { top: '54%', left: '23%',url:require('../assets/card/1/4.png')},
  { top: '60%', left: '3%',url:require('../assets/card/1/5.png') },
  { top: '59%', left: '60%',url:require('../assets/card/1/6.png') },
  { top: '73%', left: '38%',url:require('../assets/card/1/7.png') }
]

// 洗牌算法
function shuffleArray(arr) {
  const a = [...arr]
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[a[i], a[j]] = [a[j], a[i]]
  }
  return a
}

// 为每个箱子随机分配位置
function createRandomBoxes() {
  const shuffledPositions = shuffleArray(positions)
  return shuffledPositions.map((pos, index) => ({
    id: index + 1,
    ...pos
  }))
}

export default {
  name: "index",
  components: {rule, MyPrize, BoxShow,Begin,Lottery,share},
  data() {
    return {
      displayBoxes: createRandomBoxes(), // 每个箱子随机分配一个位置
      clickedBoxIds: [],
      showRule: false,
      showMyPrize: false,
      showBox: false,
      myPrizeLevel: {
        code:"",
        type:0
      },
      ShowProgress:false,
      BoxData:{},
      ShowBegin:false,// 显示开始页面
      IsBegin:true,// 是否显示首页按钮
      beginBtn: false,// 是否显示开始寻宝按钮
      DrawBtn: false,// 是否显示抽奖寻宝按钮
      GamePlay:0,
      shareMask:false,
      showLottery: false,
      LotteryTipsType: {
        data:null,
        type:-1
      },
      shareBox:false
    }
  },


  created() {

  },
  mounted() {
    reqUserInfo().then(res => {
      // if(res.data.ansList.length>=11){
      if(res.data.isDraw!=0){
        //宝箱已经收集完
        this.IsBegin = true;
        this.beginBtn = true;
      }else{
        this.beginBtn = false;
      }
      this.GamePlay = res.data.drawCount
      if(res.data.treasureCount>=4 || res.data.drawCount>0){
        this.DrawBtn = true;
      }
    })
  },

  methods: {

    //用户点击分享按钮事件回调
    userShare(){
      this.shareBox = true;
    },

    GameBeginTips(){
      this.ShowBegin = true;
    },
    GameBegin(){
      this.$router.replace('/game')
    },


    getBoxImage(id) {
      if (this.clickedBoxIds.includes(id)) {
        return require('../assets/1/boxopen/' + id + '.png')
      }
      return require('../assets/1/boxclose/' + id + '.png')
    },

    //抽奖
    requestLottery() {

      reqUserInfo().then(res => {

        if(res.data.drawCount>0){
          this.showLottery = true;
        }else{
          if(res.data.prizeId){

            this.LotteryTipsType={
              prizeId:res.data.prizeId,
              type:res.data.shareCount>0?1:-1,
              code:res.data.code
            }
          }else{
            this.LotteryTipsType={
              prizeId:"",
              type:-1,
              code:""
            }
          }

        }
        this.showLottery = true;
        this.drawMask = false;
        this.ShowProgress = false;
        this.GamePlay --;
        // if(this.GamePlay<=0){
        //   this.DrawBtn = false;
        // }

      })


    },
    //  获取我的奖品
    getMyPrize(){
      reqUserInfo().then(res => {
        this.myPrizeLevel={
          code:res.data.code,
          type:res.data.prizeId,
        }
        this.showMyPrize = true
      })
    },
    //点击开启宝藏按钮
    BeginFun(){
      this.ShowBegin = false;
      this.$router.replace('/game')
    }
  }
}
</script>

<style scoped>
.box {
  width: 80px;
  height: 80px;
}

.boxImg {
  width: 100%;
}
.index {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: url("../assets/1/bg.jpg") center no-repeat;
  background-size: cover
}

.pen {
  width: 35%;
  position: absolute;
  right: 0;
  top: 0;
}

.mapCon {
  width: 100%;
  height: 100%;
}

.mapCon .map {
  width: 100%;
  position: relative;
}

.mapCon .map .map_bg {
  width: 100%;
}

.mapCon .title {
  position: absolute;
  top: -9.5%;
  width: 100%;
  text-align: center;
  z-index: 2;
}

/*.mapCon .title{width: 100%; height: 24%; z-index: 2; position: relative;}*/
.mapCon .title img {
  width: 90%;
  margin-left: -1%;
}

.mapCon .map_mask {
  position: fixed;
  pointer-events: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}

.binocle {
  position: absolute;
  width: 30%;
  left: 0;
  bottom: 0;
  vertical-align: middle
}

.binocle img {
  vertical-align: middle
}

.LootBox {
  position: absolute;
  top: 16%;
  left: 10%;
  width: 80%;
  height: 75%;
  z-index: 2;
}

.LootBox .box {
  position: absolute;
  width: 45%;

}

.LootBox .box .boxImg {
  position: absolute;
  width: 34%;
  top: 27%;
  left: 33%;
  pointer-events: none;
}

.LootBox .box .light {
  width: 100%;
  pointer-events: none;
}

.map .manBtn {
  position: absolute;
  bottom: -7%;
  z-index: 2;
  width: 100%;
  text-align: center;
}

.map .btnAni{
  animation: scaleBtn 1s infinite linear;
}
@-webkit-keyframes scaleBtn {
  0%,100%{transform: scale(1)}
  50%{transform: scale(1.15)}
}
.map .manBtn img {
  width: 40%;
  margin: 0 -2%;
}

.mapCon .nav {
  position: absolute;
  right: 1%;
  top: 45%;
  text-align: center;
  width: 20%;
  z-index: 2;
}

.mapCon .nav span {
  display: inline-block;
  padding: 4% 12%;
  margin: 6% 0;
  vertical-align: middle;
  color: #fff;
  font-size: .85rem;
  background-color: #69431b;
  border-radius: 30px;
  cursor: pointer;
}

/* 淡入淡出过渡 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue